<template>
  <div class="comm-date-picker" :style="`width: ${width}`">
    <el-button v-if="type !== 'daterange'" class="egl-btn-yellow" @click="prevDateAction" :disabled="isPrevDisabled">
      <i class="el-icon-arrow-left"></i>
    </el-button>

    <el-date-picker
      :value-format="valueFormat"
      :clearable="false"
      v-bind="$attrs"
      :value="value"
      v-on="changeListeners"
      :disabled="disabled"
      :picker-options="pickerOptions"
      :format="pickerFormat"
      :placeholder="placeholder"
      :editable="editable"
      :type="type"
      start-placeholder="開始時間"
      end-placeholder="終了時間"
    >
    </el-date-picker>

    <el-button v-if="type !== 'daterange'" class="egl-btn-yellow" @click="nexDateAction" :disabled="isNextDisabled || type === 'daterange'">
      <i class="el-icon-arrow-right"></i>
    </el-button>
  </div>
</template>

<script>
import { weekLocaleArray } from "@/utils/common";

export default {
  name: "comm-date-picker",
  props: {
    value: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    pickerOptions: {
      type: Object,
      default: () => {},
    },
    showWeekly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default() { this.$locale("calendar.inputPlaceholder"); },
    },
    width: {
      type: String,
      default: "auto",
    },
    format: {
      type: String | Function,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "date",
    },
    stepByWeekly: {
      type: Boolean,
      default: false,
    },
    valueFormat: {
      type: String,
      default: "timestamp"
    },
    isForSchedule: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    changeStep() {
      return this.stepByWeekly ? 7 : 1;
    },
    changeListeners() {
      const vm = this;
      return Object.assign(
        {},
        this.$listeners,
        {
          change: function(_value) {
            vm.$emit("change", _value);
          }
        }
      );
    },
    nonDateValue() {
      return typeof this.value === undefined || this.value === null || this.value === "";
    },
    isPrevDisabled() {
      if (this.disabled) { return this.disabled; }
      if (this.nonDateValue) { return true; }

      let _prevDate = this.$moment(this.value).subtract(this.changeStep, "days").valueOf();
      _prevDate = new Date(_prevDate);
      const _isValidDay = this.pickerOptions && this.pickerOptions.disabledDate
        ? this.pickerOptions.disabledDate(_prevDate) : false;
      return _isValidDay;
    },
    isNextDisabled() {
      if (this.disabled) { return this.disabled; }
      if (this.nonDateValue) { return true; }

      let _nextDate = this.$moment(this.value).add(this.changeStep, "days").valueOf();
      _nextDate = new Date(_nextDate);
      const _isValidDay = this.pickerOptions && this.pickerOptions.disabledDate
        ? this.pickerOptions.disabledDate(_nextDate) : false;
      return _isValidDay;
    },
    weeklyText() {
      return weekLocaleArray[this.$moment(this.value).day()];
    },
    pickerFormat(date) {
      if (this.format) {
        return this.format;
      }

      if (this.type === "month") {
        return "yyyy-MM";
      }

      return this.showWeekly ? `yyyy-MM-dd (${this.weeklyText})` : "yyyy-MM-dd";
    },
  },
  methods: {
    prevDateAction() {
      let _prevDate = this.$moment(this.value).subtract(this.changeStep, "days").valueOf();
      if(this.valueFormat !== "date" && this.isForSchedule) {
        _prevDate = this.$moment(_prevDate).format("YYYY-MM-DD");
      }
      if (this.type === "month") {
        _prevDate = this.$moment(this.value).subtract(1, "months").valueOf();
      }

      this.$emit("change",  _prevDate);
      this.$emit("update:value",  _prevDate);
      if (this._events.reset) {
        this.$emit("reset");
      }
    },
    nexDateAction() {
      let _nextDate = this.$moment(this.value).add(this.changeStep, "days").valueOf();
      if(this.valueFormat !== "date" && this.isForSchedule) {
        _nextDate = this.$moment(_nextDate).format("YYYY-MM-DD");
      }
      if (this.type === "month") {
        _nextDate = this.$moment(this.value).add(1, "months").valueOf();
      }

      this.$emit("change",  _nextDate);
      this.$emit("update:value",  _nextDate);
      if (this._events.reset) {
        this.$emit("reset");
      }
    },
    getCellStyle(date) {
      const today = new Date();
      const isToday = date.toDateString() === today.toDateString();
      return {
        color: isToday ? "red" : "black",
        fontWeight: isToday ? "bold" : "normal",
        padding: "5px",
        textAlign: "center",
      };
    },
  },
};
</script>

<style scoped lang="less">
  .comm-date-picker {
    display: inline-flex;
    flex-direction: row;

    > .el-button,
    > .el-input {
      display: inline-block;
    }

    > .el-button {
      width: 40px;
      padding: 12px 0;
    }

    > .el-input {
      flex-grow: 1;
      width: auto;
      margin: 0 10px;
    }

    > .egl-btn-yellow:disabled {
      background-color: @secondly-light-grey;
    }

    ::v-deep + .el-button {
      margin-left: 10px;
    }
    .el-range-editor.el-input__inner {
      margin: 0 10px;
    }
  }
</style>
